import Vue from 'vue'
import Toasted from 'vue-toasted'
Vue.use(Toasted)

const config = {
  position: 'top-right',
  duration: 3000,
  className: ['vue-toast'],
  action: [
    {
      icon: 'close',
      onClick: (e, toastObject) => {
        toastObject.goAway(0)
      },
    },
  ],
}

Vue.toasted.register(
  'info',
  function(message) {
    return message
  },
  {...config, icon: 'check_circle'},
)

Vue.toasted.register(
  'error',
  function(message) {
    return message
  },
  {...config, icon: 'error', className: ['vue-toast-error']},
)

Vue.toasted.register(
  'success',
  function(message) {
    return message
  },
  {...config, icon: 'done'},
)

export default function(message, type = 'info') {
  if (type !== 'exception') {
    return Vue.toasted.global[type](message)
  }
}
